import { useEffect } from 'react';

// Production canonical origin (matches the OG/canonical base in index.html).
const SITE = 'https://www.vocalfitness.org';

/**
 * Sets a per-route document <title> and <link rel="canonical"> client-side.
 * Zero-risk SEO helper (Googlebot executes JS). Social crawlers that DON'T run
 * JS still read the static index.html defaults — per-route social meta is a
 * separate prerender/edge milestone (post-deploy).
 */
export function usePageMeta({ title, canonicalPath, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    if (canonicalPath != null) {
      const href = `${SITE}${canonicalPath}`;
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', href);
    }
    let robots = document.querySelector('meta[name="robots"][data-page-meta]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement('meta');
        robots.setAttribute('name', 'robots');
        robots.setAttribute('data-page-meta', '');
        document.head.appendChild(robots);
      }
      robots.setAttribute('content', 'noindex, nofollow');
    } else if (robots) {
      robots.remove();
    }
    return () => {
      const r = document.querySelector('meta[name="robots"][data-page-meta]');
      if (r) r.remove();
    };
  }, [title, canonicalPath, noindex]);
}

export default usePageMeta;
